/*
 * Footer Messages
 *
 * This contains all the text for the app.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  drawerHomepage: {
    id: 'drawer.homepage',
    defaultMessage: 'Homepagina'
  },
  drawerDiscover: {
    id: 'drawer.discover',
    defaultMessage: 'Ontdek'
  },
  drawerAnalyse: {
    id: 'drawer.analyse',
    defaultMessage: 'Analyseer'
  },
  drawerTips: {
    id: 'drawer.tips',
    defaultMessage: 'Tips'
  },
  drawerProfile: {
    id: 'drawer.profile',
    defaultMessage: 'Mijn gegevens'
  },
  drawerUsers: {
    id: 'drawer.users',
    defaultMessage: 'Gebruikers'
  },
  landscapeWarningTitle: {
    id: 'landscape.warning.title',
    defaultMessage: 'Opgelet'
  },
  landscapeWarningDescription: {
    id: 'landscape.warning.description',
    defaultMessage:
      'Deze applicatie kan enkel gebruikt worden in portrait mode.'
  },
  offlineWarningTitle: {
    id: 'offline.warning.title',
    defaultMessage: 'U bent offline'
  },
  offlineWarningDescription: {
    id: 'offline.warning.description',
    defaultMessage:
      'U heeft internet nodig om verder gaan. Deze melding verdwijnt automatisch wanneer u terug verbinding heeft.'
  }
});



// WEBPACK FOOTER //
// ./src/messages.js